import { Pipe, PipeTransform } from '@angular/core';
import { ExportChannel } from 'exports/interfaces/export-channels.interface';
import { ExportType } from 'exports/interfaces/export-types.interface';
import { BulkOperationType } from 'listings/enums/bulk-operation-type.enum';

@Pipe({
    name: 'exportTypesFilter',
    standalone: true,
})
export class ExportTypesFilterPipe implements PipeTransform {
    public transform(exportTypes: ExportType[], currentChannel: string, channels: ExportChannel[]): ExportType[] {
        if (!currentChannel || !channels) {
            return exportTypes;
        }

        // Find the current channel in the channels array
        const currentChannelObj = channels.find((channel) => channel.value === currentChannel);

        // Filter the export types based on the current channel
        if (!currentChannelObj) {
            return exportTypes;
        }

        let filteredExportTypes = [...exportTypes];

        if (!currentChannelObj.sendAllFromSCH) {
            filteredExportTypes = exportTypes.filter(
                (exportType) => exportType.value !== BulkOperationType.FULL_EXPORT_LISTINGS_WITHOUT_OVERRIDE_CHANNEL,
            );
        }

        if (!currentChannelObj.sendAllFromSCHWithOverrideChannel) {
            filteredExportTypes = exportTypes.filter(
                (exportType) => exportType.value !== BulkOperationType.FULL_EXPORT_LISTING_WITH_OVERRIDE_CHANNEL,
            );
        }

        return [{ value: '' as any, label: '' }, ...filteredExportTypes];
    }
}
